import { render } from "./LanguageProfile.vue?vue&type=template&id=12b9b23e&scoped=true&ts=true"
import script from "./LanguageProfile.vue?vue&type=script&lang=ts"
export * from "./LanguageProfile.vue?vue&type=script&lang=ts"

import "./LanguageProfile.vue?vue&type=style&index=0&id=12b9b23e&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b9b23e"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QIcon,QSeparator,QSelect,QItem,QItemSection,QItemLabel});
